import React from 'react';

import { useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { NoReports } from '../../assets';
import type { RenderViewProps, ReportsConfig } from '../../types';
import { ThumbnailCard } from '../thumbnail-card';

import messages from './messages';

const RenderSection = ({ sectionName, reports, id, emptyState }: ReportsConfig) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={sectionContainer}>
			<Heading level="h500">{sectionName}</Heading>
			<Box xcss={cardsContainer}>
				{reports.length === 0 ? (
					<EmptyState
						header={
							emptyState?.heading
								? emptyState.heading
								: formatMessage(messages.defaultReportsEmptyStateTitle)
						}
						description={
							emptyState?.description
								? emptyState.description
								: formatMessage(messages.defaultReportsEmptyStateDescription)
						}
						headingLevel={4}
						imageUrl={emptyState?.imageUrl ? emptyState.imageUrl : NoReports}
					/>
				) : (
					<>
						{reports.map((report, i) => (
							<ThumbnailCard key={i} {...report} />
						))}
					</>
				)}
			</Box>
		</Box>
	);
};

export const ThumbnailView = ({ reportsConfig }: RenderViewProps) => (
	<>
		{reportsConfig.map((section) => (
			<RenderSection key={section.id} {...section} />
		))}
	</>
);

const sectionContainer = xcss({
	// @ts-expect-error TS2322
	marginTop: token('space.300'),
	display: 'flex',
	flexDirection: 'column',
	// @ts-expect-error TS2322
	gap: token('space.200'),
});

const cardsContainer = xcss({
	display: 'flex',
	flexDirection: 'row',
	// @ts-expect-error TS2322
	gap: token('space.200'),
	alignItems: 'flex-start',
	flexWrap: 'wrap',
});
